import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

interface InputStylesProps {
  variant?: 'filled' | 'outlined' | 'standard';
  size?: 'large' | 'small' | number;
}

const getInputSize = (size: InputStylesProps['size']) => {
  switch (size) {
    case 'large':
      return 40;
    case 'small':
      return 32;
    default:
      return size;
  }
};

const styles = makeStyles<Theme, InputStylesProps>(theme => ({
  errorMessage: {
    bottom: theme.spacing(-3),
    position: 'absolute',
    right: 0,
  },
  focused: {
    '&.error': {
      border: theme.customBorders.primary,
    },
    backgroundColor: `${theme.palette.common.white} !important`,
    border: `${theme.customBorders.primary} !important`,
  },
  formControl: {
    position: 'relative',
    width: '100%',
  },
  input: {
    '&.centered': {
      textAlign: 'center',
    },
    '&::placeholder': {
      color: theme.palette.common.gray600,
      opacity: 1,
    },
    '&[type="number"]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '&[type="number"]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    fontSize: '0.875rem',
    padding: 0,
  },
  inputAdornment: {
    height: '100%',
  },
  label: {
    '&.required': {
      '&:after': {
        color: 'red',
        content: "' *'",
        display: 'inline',
        marginLeft: theme.spacing(0.5),
        position: 'absolute',
      },
    },
    marginBottom: theme.spacing(0.5),
    position: 'relative',

    textTransform: 'capitalize',
  },
  multiline: {
    height: 'initial',
    minHeight: ({ size }) => getInputSize(size),
  },
  root: {
    '&.error': {
      border: theme.customBorders.error,
    },
    backgroundColor: ({ variant }) =>
      variant === 'filled' ? theme.palette.background.default : theme.palette.common.white,
    border: ({ variant }) => (variant === 'filled' ? theme.palette.background.default : theme.customBorders.gray400),
    borderRadius: theme.spacing(0.5),
    height: ({ size }) => getInputSize(size),
    padding: theme.spacing(0, 2),
    transition: 'border-color 0.3s ease',
    whiteSpace: 'nowrap',
    width: '100%',
  },
  stripeInput: {
    '& .__PrivateStripeElement': {
      width: '100%',
    },
    alignItems: 'center',
    display: 'inline-flex',
  },
}));

export default styles;
